/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationsTimingSettingsUpdateRequest
 */
export interface MatchOperationsTimingSettingsUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsTimingSettingsUpdateRequest
     */
    regularPeriodCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsTimingSettingsUpdateRequest
     */
    regularPeriodDurationMinutes?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatchOperationsTimingSettingsUpdateRequest
     */
    overtimeEnabled?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsTimingSettingsUpdateRequest
     */
    overtimePeriodCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsTimingSettingsUpdateRequest
     */
    overtimePeriodDurationMinutes?: number | null;
}

/**
 * Check if a given object implements the MatchOperationsTimingSettingsUpdateRequest interface.
 */
export function instanceOfMatchOperationsTimingSettingsUpdateRequest(value: object): value is MatchOperationsTimingSettingsUpdateRequest {
    return true;
}

export function MatchOperationsTimingSettingsUpdateRequestFromJSON(json: any): MatchOperationsTimingSettingsUpdateRequest {
    return MatchOperationsTimingSettingsUpdateRequestFromJSONTyped(json, false);
}

export function MatchOperationsTimingSettingsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsTimingSettingsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'regularPeriodCount': json['regularPeriodCount'] == null ? undefined : json['regularPeriodCount'],
        'regularPeriodDurationMinutes': json['regularPeriodDurationMinutes'] == null ? undefined : json['regularPeriodDurationMinutes'],
        'overtimeEnabled': json['overtimeEnabled'] == null ? undefined : json['overtimeEnabled'],
        'overtimePeriodCount': json['overtimePeriodCount'] == null ? undefined : json['overtimePeriodCount'],
        'overtimePeriodDurationMinutes': json['overtimePeriodDurationMinutes'] == null ? undefined : json['overtimePeriodDurationMinutes'],
    };
}

export function MatchOperationsTimingSettingsUpdateRequestToJSON(json: any): MatchOperationsTimingSettingsUpdateRequest {
    return MatchOperationsTimingSettingsUpdateRequestToJSONTyped(json, false);
}

export function MatchOperationsTimingSettingsUpdateRequestToJSONTyped(value?: MatchOperationsTimingSettingsUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'regularPeriodCount': value['regularPeriodCount'],
        'regularPeriodDurationMinutes': value['regularPeriodDurationMinutes'],
        'overtimeEnabled': value['overtimeEnabled'],
        'overtimePeriodCount': value['overtimePeriodCount'],
        'overtimePeriodDurationMinutes': value['overtimePeriodDurationMinutes'],
    };
}

